import React from 'react'
import PropTypes from 'prop-types'

import ActionButton from '../../../reusablePreviewComponents/ActionButton'

import { ReactComponent as ArrowIcon } from '../../../../../../assets/icons/chevron-arrow-down.svg'

import useStyles from './styles'

const StoryButton = ({ actionValue }) => {
  const classes = useStyles()

  return (
    <div className={classes.adStoriesCardButton}>
      <ArrowIcon className={classes.adStoriesCardIcon} />
      <ActionButton actionValue={actionValue} className={classes.storyActionButton} />
    </div>
  )
}

StoryButton.propTypes = {
  actionValue: PropTypes.string
}

export default StoryButton
